import React, { Component } from "react";
//TODO: remove these lines?
import { Col, FormGroup, FormControl, FormCheck, Button, ControlLabel } from 'react-bootstrap';
import { Form, Checkbox } from 'react-bootstrap';
import Feedback from './Feedback';
import Highlights from './Highlights';
import Suggestions from './Suggestions';
import Stories from './Stories';
import "./assets/feature.scss";

export default class Feature extends Component {

  constructor(props) {
    super(props);
    this.feature = props.name;
  }

  render() {

    switch (this.feature) {
      case 'stories':
        this.title = "Your Stories";
        return (
          <div className={`${this.feature} feature container`}>
            <h2 className="section-title">{this.title}</h2>
            <Stories />
          </div>
        );
      case 'asmr':
          this.title = "Have you tried ASMR?";
          return (
            <div className={`${this.feature} feature container`}>
              <Suggestions />
            </div>
          );
      case 'feedback':
          this.title = "We need your feedback";
          return (
            <div className={`${this.feature} feature container`}>
              <h2 className="section-title">{this.title}</h2>
              <Feedback />
            </div>
          );
      default:
        this.title = 'Our Features';
        return (
          <div className="features feature container">
            <h2 className="section-title">{this.title}</h2>
            <Highlights />
          </div>
        );
    }

  }


}



// WEBPACK FOOTER //
// ./src/containers/main/features/Feature.js